import { StandardEvents } from '@shopify/events';

/**
 * <loyalty-points> — keeps the PDP's "Earn N points" line in step with the selected variant.
 *
 * The point total is a function of the variant's PRICE, so it has to move whenever the price does.
 * This mirrors assets/product-price.js exactly: listen for productSelect on the surrounding
 * section, then lift this element's counterpart out of the re-fetched product HTML by block id.
 * Reusing that mechanism (rather than recomputing from a parsed price string) keeps the rate and
 * the rounding in Liquid, where the block already defines them.
 */
class LoyaltyPoints extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    if (!this.section) return;
    this.section.addEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  handleProductSelect = (event) => {
    // Swatch changes on a product CARD must not rewrite the PDP's line.
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        if (!detail?.html) return;

        if (detail.newProduct) {
          this.dataset.productId = detail.newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const next = detail.html.querySelector(`loyalty-points[data-block-id="${this.dataset.blockId}"]`);
        const target = this.querySelector('[ref="text"]');
        const source = next?.querySelector('[ref="text"]');
        // A variant with no price (or a product that drops off the campaign) renders no block at
        // all, so leave the current line alone rather than blanking it.
        if (!source || !target) return;
        target.innerHTML = source.innerHTML;
      })
      .catch(() => {});
  };
}

if (!customElements.get('loyalty-points')) {
  customElements.define('loyalty-points', LoyaltyPoints);
}
